import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const { public: { sentry } } = useRuntimeConfig()

  

  // if (!sentry.dsn) {
  //   return
  // }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: "https://e02a48fdfd016faf6daa29d7b713b025@o1157437.ingest.us.sentry.io/4507669060452352",
    integrations: [
      Sentry.browserTracingIntegration({ router }), 
  
    ],

    // Configure this whole part as you need it!

    tracesSampleRate: 0.2, // Change in prod

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'https://your-server.com'],

  })
})
    

  // export default defineNuxtPlugin((nuxtApp) => {
  //   const config = useRuntimeConfig();
  //   const router = useRouter();
  
  //   Sentry.init({
  //     app: nuxtApp.vueApp,
  //     dsn: config.public.sentry_dsn,
  //     environment: config.public.sentry.env,
  //     integrations: [
  //       new BrowserTracing({
  //         routingInstrumentation: vueRouterInstrumentation(router), // Use the direct import
  //       }),
  //     ],
  //     tracesSampleRate: 1.0,
  //   });
  
  //   return {
  //     provide: {
  //       sentry: Sentry,
  //     },
  //   };
  // });
